import { render, staticRenderFns } from "./dom-des.vue?vue&type=template&id=71f8c549&scoped=true"
import script from "./dom-des.vue?vue&type=script&lang=ts"
export * from "./dom-des.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f8c549",
  null
  
)

export default component.exports